import { Link } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function RouteErrorBoundary({
  error,
  title = 'Something went wrong',
  retryLabel = 'Try Again',
  onRetry = () => window.location.reload(),
}: {
  error?: unknown
  title?: string
  retryLabel?: string
  onRetry?: () => void
}) {
  let message = 'An unexpected error occurred. Please try again.'

  if (error instanceof Error) {
    message = error.message
  }

  return (
    <div className="flex flex-col justify-center items-center h-dvh gap-4 p-4">
      <AlertTriangle className="h-12 w-12 text-destructive" />
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="text-muted-foreground text-center max-w-md">{message}</p>
      <div className="flex gap-3 mt-2">
        <Button variant="outline" onClick={onRetry}>
          {retryLabel}
        </Button>
        <Button asChild>
          <Link to="/">Go Home</Link>
        </Button>
      </div>
    </div>
  )
}
